import * as React from "react";
import * as StateLib from "@/Utils/StateLib";
import SectionCard, { SectionCardGroup } from "../../../../Composites/SectionCard/SectionCard";
import { useEffect } from "react";
import { FieldTextGroup, Flex } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { kVersionStr } from "@coreapp/constants";
import { Globals } from "@coreapp/CoreApp/Globals";

export const ApplicationDetails = () => {
  const wsMgr = StateLib.GetWSMgr();

  useEffect(() => {
    const eventTracker = wsMgr.GetUsageTracker();
    eventTracker.ReportEvent("account_settings.application_details.opened");
  }, []);

  const addFieldText = (field, value, data, testId) => {
    data.push({ field: field, value: value, "data-testid": testId });
  };

  const getData = () => {
    const serverName = window.location.host;

    const data = [];
    addFieldText(appstr("Application"), kVersionStr, data, "app-details-application");
    addFieldText(appstr("Browser"), Globals._browserStr, data, "app-details-browser");
    addFieldText(appstr("Server"), serverName, data, "app-details-server");
    return data;
  };

  return (
    <SectionCardGroup>
      <SectionCard title={appstr("appinfo")}>
        <Flex direction={"column"} gap={"8px"} height={"100%"}>
          <FieldTextGroup columnGap={16} columns={1} data={getData()} size={"large"} />
        </Flex>
      </SectionCard>
    </SectionCardGroup>
  );
};
